import { Stack, Typography } from '@mui/material';
import { CustomTelInput } from '../../common/CustomTelInput/CustomInput';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from '@mui/lab';
import { validationChangePhoneSchema } from './validationSchema';
import React from 'react';
import { StyledForm } from '../../common/StyledForm/StyledForm';
import { authService } from '../../../services/auth/AuthService';
import { useChangeFieldForm } from '../../../hooks/useChangeFieldForm';
import { toMaskedUaPhone } from '../../../utils/phone';

export const ChangePhoneForm: React.FC<{
  phone?: string;
  cb: () => void;
  btnText: string;
}> = ({ phone, cb, btnText }) => {
  const { t } = useTranslation();

  const {
    values,
    errors,
    handleSubmit,
    touched,
    setFieldValue,
    setFieldTouched,
    checkDisableButton,
  } = useChangeFieldForm(
    // Seed with the fully masked string; a controlled InputMask renders its
    // value verbatim and only formats further input as the user types.
    toMaskedUaPhone(phone),
    'phone',
    validationChangePhoneSchema(t),
    authService.changePhone.bind(authService),
    'profilePage.updatePhoneForm.phoneIsAlreadyInUse',
    cb,
  );

  const handleChangePhone = (newValue: string) => {
    setFieldValue('phone', newValue, true);
  };

  return (
    <StyledForm onSubmit={handleSubmit}>
      <Stack direction="column" sx={{ marginTop: '30px', gap: '15px' }}>
        <Typography color="common.white">
          {t('profilePage.updatePhoneForm.formTitle')}
        </Typography>
        <Stack
          sx={{
            gap: '15px',
            display: 'grid',
            gridTemplateColumns: '1fr 110px',
          }}
        >
          <CustomTelInput
            fieldName={'phone'}
            label={t('userAuth.phonePlaceholder')}
            value={values.phone || ''}
            onChange={(value) => {
              setFieldTouched('phone');
              handleChangePhone(value);
            }}
            error={touched['phone'] && errors.phone}
          />
          <LoadingButton
            variant="contained"
            color="primary"
            type="submit"
            sx={{
              flex: '1 1 auto',
              padding: '10px',
              maxHeight: '50px',
              maxWidth: '110px',
              width: '100%',
            }}
            disabled={checkDisableButton()}
          >
            {btnText}
          </LoadingButton>
        </Stack>
      </Stack>
    </StyledForm>
  );
};
